import apiClient from '../../../services/apiClient';
import uuid from '../../../services/uuid';

export const getRedirectToLoginFromLoggedOutState = (host: string, redirectUrl: string, loginHint?: string) => {
  return apiClient
    .post('/v1/sign-in', { host: host, state: uuid.generate(), loginHint }, redirectUrl)
    .then(res => res.data);
};
